import { useEffect } from "react";
import { TextField, Grid } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import {
  JSafe,
  resetForm,
  setSafeTransferPageDialog,
} from "../../../../../app/slices/jomla/safeSlice";
import { SelectJSafe } from "../../../../../components/Selectors/jomla/SelectJSafe";
import { NumericFormat } from "react-number-format";
import { toNumber } from "../../../../../helpers/toNumber";
import { HiOutlineArrowsRightLeft, HiOutlineBanknotes } from "react-icons/hi2";
import FormDialog, { SectionCard } from "../../../../../components/FormDialog";

const JSafeTransferForm = () => {
  const _JSafeTransfer = useSelector((state) => state.jSafe.jSafeTransfer);
  const _SearchBody = useSelector(
    (state) => state.jSafe.jSafeTransfer.searchBody
  );
  const jSafe = useSelector((state) => state.jSafe.jSafes.data);

  const { control, reset, handleSubmit, setValue } = useForm({
    defaultValues: _JSafeTransfer.form,
  });

  const onSubmit = (data) => {
    dispatch(
      JSafe.safeTransfer(
        {
          from_safe_id: data.from_safe_id,
          safe_id: data.safe_id,
          amount: data.amount,
        },
        _SearchBody
      )
    );
  };
  useEffect(() => {
    reset({ ..._JSafeTransfer.form });
  }, [_JSafeTransfer.form, reset]);

  useEffect(() => {
    return () => {
      dispatch(resetForm());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const dispatch = useDispatch();

  const handleDialog = () => {
    dispatch(setSafeTransferPageDialog());
  };

  return (
    <FormDialog
      open={_JSafeTransfer.dialog}
      onClose={() => {
        handleDialog();
      }}
      icon={<HiOutlineArrowsRightLeft />}
      title={"تحويل كاش بين الخزنات"}
      subtitle="اختر الخزنتين وأدخل المبلغ لإتمام التحويل"
      onSubmit={handleSubmit(onSubmit)}
    >
      <SectionCard icon={<HiOutlineBanknotes />} title="معلومات التحويل">
        <Grid item xs={12} sm={6}>
          <Controller
            name="from_safe_id"
            control={control}
            render={({ field }) => (
              <SelectJSafe
                {...field}
                required
                noapirequest
                label="من خزنة"
                onChange={(e, newValue) => {
                  setValue("from_safe_id", newValue ? newValue.id : null);
                }}
                value={jSafe.filter((x) => x.id === field.value)[0] ?? null}
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Controller
            name="safe_id"
            control={control}
            render={({ field }) => (
              <SelectJSafe
                {...field}
                required
                label="الى خزنة"
                onChange={(e, newValue) => {
                  setValue("safe_id", newValue ? newValue.id : null);
                }}
                value={jSafe.filter((x) => x.id === field.value)[0] ?? null}
              />
            )}
          />
        </Grid>
        <Grid item xs={12}>
          <Controller
            name="amount"
            control={control}
            render={({ field }) => (
              <NumericFormat
                thousandSeparator
                customInput={TextField}
                value={field.value}
                onChange={(e) => {
                  setValue("amount", toNumber(e.target.value));
                }}
                valueIsNumericString={true}
                allowNegative={false}
                fullWidth
                label="المبلغ"
                size="small"
              />
            )}
          />
        </Grid>
      </SectionCard>
    </FormDialog>
  );
};

export default JSafeTransferForm;
